// @ts-nocheck
// LIBRARY
import React from 'react';
import { Row, Col, Table, Button, Input, Drawer, Tag, Typography } from 'antd';
import TablePager from 'shared_components/table_pager';
import { UserAccessContext } from 'context/userAccess';
import { PlusOutlined } from '@ant-design/icons';


// CUSTOM
import { getUserAccountsAPI } from 'services/settings/userAccount';
import { showMessage } from 'services/settings/message';
import { 
	drawerAdd, 
	drawerUpdate, 
	drawerUpdateTitle, 
	drawerAddTitle, 
	addUserButton, 
	tableHeaders, 
	tablePageSize,
	tableSize ,
	tableYScroll
} from '../settings';
import UserAccountForm from '../user_account_form';

// CSS
import './usertable.css';

const { Search } = Input;
const { Text } = Typography;
const columns = [
	// {
	// 	title: tableHeaders.userID,
	// 	dataIndex: 'userID',
	// 	key: 'userID',
	// 	width: 150,
	// 	sorter: (a, b) => a.userID - b.userID,
	// },
	{
		title: tableHeaders.userName,
		dataIndex: 'userName',
		key: 'userName',
		width: 150,
		sorter: (a, b) => a.userName.localeCompare(b.userName),
	},
	{
		title: tableHeaders.lastName,
		dataIndex: 'lastName',
		key: 'lastName',
		width: 150,
		sorter: (a, b) => a.lastName.localeCompare(b.lastName),
	},
	{
		title: tableHeaders.firstName,
		dataIndex: 'givenName',
		key: 'givenName',
		width: 150,
		sorter: (a, b) => a.givenName.localeCompare(b.givenName),
	},
	{
		title: tableHeaders.middleName,
		dataIndex: 'middleName',
		key: 'middleName',
		width: 150,
		sorter: (a, b) => a.middleName.localeCompare(b.middleName),
	},
	{
		title: tableHeaders.userTypes,
		dataIndex: 'userTypeName',
		key: 'userTypeName',
		width: 150,
		sorter: (a, b) => a.userTypeName.localeCompare(b.userTypeName),
	},
	{ 
		title: 'STATUS',
		dataIndex: 'active',
		width: 100,
		render: active => (
			<Tag color={active === 0 ? "red" : "green"}>
				{active === 0 ? 'INACTIVE' : 'ACTIVE'}
			</Tag>
		)
	}
];

class UserTable extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			drawerTitle: '',
			drawerButton: '',
			patientInfo: [],
			usersRef: [],
			users: [],
			userMatrix: [],
			userId: [],
			createRequest: false,
			editRequest: false,
			pagination: {
				current: 1,
				pageSize: tablePageSize,
				showSizeChanger: false
			},
			loading: false
		}
	}
	
	
	async componentDidMount(){
		this.fetchUsers();
	}

	fetchUsers = async () => {
		this.setState({loading:true});
		const userAccounts = await getUserAccountsAPI();

		this.setState({
			pagination: userAccounts.data.length,
			users: userAccounts.data,
			usersRef: userAccounts.data,
			loading:false
		});
	}

	showDrawer = () => {

		this.setState({
			visible: true,
			drawerTitle: drawerAddTitle,
			drawerButton: drawerAdd,
			patientInfo: [],
		});
	};

	onClose = () => {
		this.setState({
			visible: false,
			patientInfo: [],
		});
	};

	onSearch = (value) => {
		const { usersRef, pagination } = this.state;
		const searchedVal = value.toLowerCase();

		const filtered = usersRef.filter(item => {
			const { userName, lastName, givenName } = item;

			return (
				this.containsString(userName, searchedVal) ||
				this.containsString(lastName, searchedVal) ||
				this.containsString(givenName, searchedVal)
			);
		});

		// Show "No result found" message if no results
		if (filtered.length === 0 && value.trim() !== '') {
			showMessage('M0001');
		}

		// Reset to page 1 when searching
		this.setState({
			users: filtered,
			pagination: { ...pagination, current: 1 }
		});
	}

	onChangeSearch = (event) => {
		const { usersRef } = this.state;

		if(event.target.value === '') 
			this.setState({ users: usersRef });
	}

	displayDrawerUpdate = (record) => {
		this.setState({
			visible: true,
			drawerTitle: drawerUpdateTitle,
			drawerButton: drawerUpdate,
			patientInfo: record
		});
	}

	handleSelectChange = (value) => {
		// eslint-disable-next-line react/no-access-state-in-setstate
		const pagination = {...this.state.pagination};
		// eslint-disable-next-line radix
		pagination.pageSize = parseInt(value);
		pagination.current = 1; // Reset to page 1 when changing page size
		this.setState({ pagination });
	};

	handleTableChange = (paginationConfig) => {
		const { pagination } = this.state;
		this.setState({
			pagination: { ...pagination, current: paginationConfig.current }
		});
	};

	// Private Function
	containsString = (searchFrom, searchedVal) => {
		if(searchFrom === null || searchFrom === '')
			return false;

		return searchFrom.toString().toLowerCase().includes(searchedVal);
	}

	render() {
		const { users, usersRef, pagination, drawerButton, patientInfo, visible, drawerTitle, loading } = this.state;

		// Calculate result count display (same logic as SearchPager component)
		const pageSize = pagination.pageSize || tablePageSize;
		const currentPage = pagination.current || 1;
		const pageTotal = users.length;
		const totalRecords = usersRef.length;
		const minPage = (currentPage * pageSize) + 1 - pageSize;
		const maxPage = currentPage * pageSize;

		const resultCountText = (() => {
			if (pageTotal === 0) {
				return 'Showing 0 results';
			} else if (pageTotal <= maxPage) {
				return `Showing ${minPage} - ${pageTotal} items out of ${totalRecords} results`;
			} else {
				return `Showing ${minPage} - ${maxPage} items out of ${totalRecords} results`;
			}
		})();

		return(
			<div>
				<div className="settings-user-table-action">
					<Row>
						<Col span={12}>
							<Search
								allowClear
								onSearch={value => this.onSearch(value)}
								onChange={this.onChangeSearch}
								style={{ width: 300, textTransform: 'uppercase' }}
								placeholder='Username, Last Name, First Name'
							/>
						</Col>
						<Col span={12} style={{ textAlign: 'right' }}>
								<UserAccessContext.Consumer>
									{value => value.userAccess.settings.create && (
										<Button
											type="primary"
											shape="round"
											style={{ marginRight: '15px' }}
											onClick={this.showDrawer}
										>
											<PlusOutlined />
											{addUserButton}
										</Button>
									)}
							</UserAccessContext.Consumer>
							<TablePager handleChange={this.handleSelectChange} />
						</Col>
					</Row>
				</div>
				<div style={{ marginTop: 10, marginBottom: 10 }}>
					<Text type="secondary">
						{resultCountText}
					</Text>
				</div>
				<div className="settings-user-table">
					<Table
						loading={loading}
						size={tableSize}
						scroll={{ x: true }}
						columns={columns}
						dataSource={users}
						pagination={{ ...pagination, showSizeChanger: false }}
						onChange={this.handleTableChange}
						rowKey={record => record.userID}
						onRow={(record) => {
							return {     
								onDoubleClick: () => {
									const rec = [];
									// eslint-disable-next-line no-restricted-syntax
									for(const [key, value] of Object.entries(record)){
										rec[key] = value;
									}
									this.displayDrawerUpdate(rec);
								}
							}
						}}
					/>
				</div>    

				<Drawer
					title={drawerTitle}
					width="85%"
					visible={visible}
					onClose={this.onClose}
					destroyOnClose
				>
					<UserAccountForm
						drawerButton={drawerButton} 
						patientInfo={patientInfo}
						onClose={this.onClose}
						onSuccess={this.fetchUsers}
					/>
				</Drawer>
			</div>
		)
	}
}


export default UserTable;